import React from "react";

export const Logo = ({ collapsed }) => {
  return (
    <div className="logo">
      <img
        src={
          collapsed
            ? "/images/logo_white_notypo.png"
            : "/images/logo_white_horizontal.png"
        }
        alt="Logo"
      />
    </div>
  );
};
